

























import {Component, Vue} from 'vue-property-decorator'
import userSession from "@/store/module/UserSession";
import LangSelect from "@/component/LangSelect/index.vue"
import UserApi from "@/api/UserApi";
import {Inject} from "typescript-ioc";
import envconfig from "@/config/EnvConfig";
import DingtalkLogin from "@/module/dingtalk/login/index.vue";

@Component({
    components: {
        LangSelect,
        DingtalkLogin,
    }
})
export default class LoginView extends Vue {

    @Inject
    private userApi!: UserApi

    private dingtalkcfg = envconfig.dingtalk

    private created() {
        if (userSession.isLogged)
            this.$redirector.redirectWithFrom()
    }

    private async dingtalkLoginCallback(code: string) {
        this.$message.success("登录中, 请稍等...")
        const user = await this.userApi.ddlogin({
            code: code
        })
        await userSession.activate(user)
        this.$redirector.redirectWithFrom()
    }

    private currentYear() {
        return new Date().getFullYear()
    }
}
